const view = require('./view');
const sectionDetailsFactory = require('components/flights/section_details/js/main.desktop');
const tripTypeUtils = require('../../modules/utils/trip_type');

const KLM = 'KL';
const AIRFRANCE = 'AF';

module.exports = Odigeo.View.extend(Odigeo._.merge({}, view, {
    dealWithCloseFlightSummary: () => {},

    fillFlightRowTemplate($parent, section, index, technicalStopDep, technicalStopArr, isTechnicalStop, hideTimeLine, alignWithTitle) {
        const sectionId = this.generateSectionId(section, index, isTechnicalStop);
        const sectionClass = `od-section-details ${Odigeo.AB.isNewTripDetails && this.options.isResults ? 'od-collapsible-section-box' : ''}`;
        $('<div/>', {id: sectionId, class: sectionClass}).appendTo($parent);
        const transportType = this.getTransportType();
        const pureTrain = transportType === 'TRAIN';
        const hasTrains = transportType !== 'PLANE';
        sectionDetailsFactory.create({
            el: $parent.find(`#${sectionId}`),
            options: {
                templateName: this.options.isResults ? 'vertical' : 'horizontal',
                section,
                index,
                technicalStopDep,
                technicalStopArr,
                isTechnicalStop,
                hideTimeLine,
                alignWithTitle,
                sectionId,
                pureTrain,
                hasTrains,
                isResults: this.options.isResults,
            },
        });
    },

    shouldShowFareType(segments) {
        const isABActive = Odigeo.AB.isFareTypeInCollapsibleSummary;
        const carriers = segments.map((segment) => segment.carrier ? segment.carrier.code : null);
        const allValidCarriers = carriers.every((carrier) => carrier === KLM || carrier === AIRFRANCE);
        const allValidBaggages = segments.every((segment) => segment.baggage.includedType === 'CABIN_INCLUDED');
        const isMultiDestination = tripTypeUtils.isMultipleDestinations(this.model.get('tripType'));
        const isPaymentPage = this.options.page === 'payment';
        return isABActive && allValidCarriers && allValidBaggages && !isMultiDestination && !isPaymentPage;
    },

    renderFareType() {
        this.$el.find('.fare_type_container')
            .removeClass('odf-hidden')
            .html(this.templates.fareType({
                keys: this.keys,
            }));
    },

    resultsLightbox(cssClass) {
        new Odigeo.UIElements.Lightbox(this.$el.find('.results_desktop_wrapper'), {
            closeOnOuterClick: true,
            overFullPage: false,
            onClose: Odigeo._.bind(this.onResultsCloseButton, this),
            cssClass,
        }).toggle(true);
    },

    paxAndPayLightbox() {
        return new Odigeo.UIElements.Lightbox(this.$el.find('.pax_pay_desktop_wrapper'), {
            closeOnOuterClick: true,
            overFullPage: false,
        });
    },

    getSegmentHeader(segment, index, tripType) {
        const options = {
            segmentName: this.getSegmentName(index, tripType),
            duration: Odigeo.Utils.convertMinutesToPattern(segment.duration, this.keys.durationShortPattern),
            transports: Odigeo.AB.isNewTripDetails ? this.getSegmentTransports(segment): this.getTransportsOrdered(),
            numStops: segment.stops,
            stopsMsgText: (segment.stops > 1) ? this.keys.stopsMsgText : this.keys.stopMsgText,
            isResults: this.options.isResults,
        };
        return $(this.templates.segmentHeader(options));
    },

    fillUnfoldedSummary(segments, $appendTo) {
        const $wrapper = this.$el.find('.flight_details_wrapper .collapsible_content');
        const $flightDetailsCollapsibleContent = $appendTo || $wrapper.empty();
        segments.forEach((segment, index) => {
            const segmentNumber = this.options.isResults ? this.model.get('segmentNumber') : index;
            $flightDetailsCollapsibleContent.append(
                this.fillSegmentHeaderTemplate(segment, segmentNumber, this.model.get('tripType'))
            );
        });
        this.updateDomSelectorsToCache();
    },

    adjustForOneWay() {
        const isOneWay = tripTypeUtils.isOneWay(this.model.get('tripType'));
        this.$el.find('.flight_box_layer').toggleClass('odf-lightbox-md', isOneWay);
    },

    adjustForMultiTrip(numberOfSegments) {
        const isMT = tripTypeUtils.isMultipleDestinations(this.model.get('tripType'));
        const moreThan3Segments = isMT && numberOfSegments > 3;
        const threeSegments = isMT && numberOfSegments === 3;

        this.$el.find('.flight_box_layer')
            .toggleClass('odf-lightbox-md od-collapsible-flight-summary-multidestination', moreThan3Segments)
            .toggleClass('od-lightbox-xl', threeSegments);
        this.$el.find('.flight_details_wrapper').toggleClass('odf-flex-container-wrap', moreThan3Segments);
        this.$el.find('.collapsible_segment_container').toggleClass('odf-space-outer-bottom-l', moreThan3Segments);
        this.$el.find('.collapsible_segment_container').toggleClass('odf-flex-item-span-4', threeSegments);
    },
}));
